import React, { Component, Fragment } from 'react';
import { withApollo } from 'react-apollo';

import View from './View';
import ConfirmationModal from '../../modals/ConfirmationModal';
import { UpdatePassengerTicket } from '../../../mutations/UpdatePassengerTicket';

class TicketInformation extends Component {
  state = { unclaimable: undefined };

  setClaimableStatus = test => {
    const { unclaimable } = this.state;
    const {
      onTicketUpdated,
      hideLoading,
      showLoading,
      client,
      match
    } = this.props;
    this.setState({ unclaimable: undefined });
    if (!test) return;
    showLoading();
    client
      .mutate({
        mutation: UpdatePassengerTicket,
        variables: {
          input: {
            ticket: {
              unclaimable: unclaimable,
              id: match.params.id
            }
          }
        }
      })
      .then(() => {
        hideLoading();
        onTicketUpdated();
      })
      .catch(() => {
        hideLoading();
      });
  };

  handleMarkAsEligible = () => this.setState({ unclaimable: false });

  handleMarkAsIneligible = () => this.setState({ unclaimable: true });

  render() {
    const { unclaimable } = this.state;
    return (
      <Fragment>
        <ConfirmationModal
          question={`Are you sure you want to mark this ticket as ${
            unclaimable ? 'unclaimable' : 'claimable'
          }?`}
          isOpen={unclaimable !== undefined}
          onConfirmation={this.setClaimableStatus}
        />
        <View
          {...this.props}
          onMarkAsEligible={this.handleMarkAsEligible}
          onMarkAsIneligible={this.handleMarkAsIneligible}
        />
      </Fragment>
    );
  }
}

export default withApollo(TicketInformation);



// WEBPACK FOOTER //
// ./src/component/TicketPage/TicketInformation/index.js